<template>
  <div class="rootTable">
    <header class="mint-header is-fixed" style="border-bottom: 1px solid gainsboro;background: white">
      <div style="float: left;">
        <img src="../../../../assets/images/32/change.png" @click="changePage()"
             style="margin-right:20px ;padding: 0;margin-top: 0.5rem" height="20"
             width="20"
             slot="icon" alt="">
      </div>
      <div style="width: 30rem;height: 32px;" class="mint-search searchstyle">
        <div class="mint-searchbar" style="padding: 0">
          <div class="mint-searchbar-inner">
            <i class="mintui mintui-search"/>
            <input type="search" placeholder="搜索" class="mint-searchbar-core" style="color: black" v-model="searchKey"
                   @input="search()"/>
            <a class="mint-searchbar-cancel" style="display: none;">取消</a>
          </div>
          <div class="mint-search-list" style="display: none;">
            <div class="mint-search-list-warp"/>
          </div>
        </div>
      </div>
      <div style="float: left;">
      </div>
    </header>
    <div>
      <ul>
        <li v-for="item in BirthdayList" :key="item.birthdayInfoModel.iD" @click="analysis(item.birthdayInfoModel.iD)">
          <div style="border: solid 0.1rem black;background-color: beige;margin-top: 0.2rem">
            <div>
              <div v-html="$options.filters.font_color(item.birthdayInfoModel)" style="float: left"></div>
              <div style="height: 24px;float: left;margin-top: 0.1rem">
                <img v-if="item.birthdayInfoModel.sex === '男'" src="../../../../assets/images/16/man.png" alt=""/>
                <img v-else src="../../../../assets/images/16/woman.png" alt=""/>
              </div>
              <div style="float: left;margin-left: 0.2rem">
                <img v-if="item.birthdayInfoModel.isBirthday" src="../../../../assets/images/32/birthday.png" width="20"
                     height="20"
                     alt=""/>
              </div>
              <div style="float: left">
                <span style="font-size: 1rem;color: gray">{{
                    item.starInfoModel.zY ? ("(" + item.starInfoModel.zY + ")") : ''
                  }}</span>
              </div>
              <div style="clear: both"></div>
            </div>
            <div>
              <div style="float: left;width: 36%;text-align: right">
                <div class="div-right2-top">
                  <span style="font-size: 0.8rem">{{ item.starInfoModel.gJ }}</span>
                </div>
                <div class="div-right2-bottom"
                     :style="{'color': item.birthdayInfoModel.deadDate !== null?'gray':'blue'}">
                  <span style="font-size: 0.8rem">
                    {{ item.starInfoModel.sG > 0 ? (item.starInfoModel.sG + 'cm') : '身高：未知' }}
                    {{ item.starInfoModel.tZ > 0 ? (item.starInfoModel.tZ + 'kg') : ' 体重：未知' }}
                  </span>
                </div>
                <div style="clear:both;">
                </div>
              </div>
              <div style="float: left;width: 38%">
                <div>
                  <span style="font-size: 0.8rem">{{ item.birthdayInfoModel.dateOfBirth }}</span>
                </div>
                <div :style="{'color': item.birthdayInfoModel.deadDate !== null?'gray':'blue'}">
                  <span style="font-size: 0.8rem;margin-right: 5px">{{ item.birthdayInfoModel.age }}</span>
                  <span style="font-size: 0.8rem;margin-right: 5px" v-if="item.birthdayInfoModel.deadDate !== null">{{
                      item.birthdayInfoModel.realAge
                    }}</span>
                  <span style="font-size: 0.8rem;margin-right: 5px">{{ item.birthdayInfoModel.zodiac }}</span>
                  <span style="font-size: 0.8rem">{{ item.birthdayInfoModel.constellation }}</span>
                </div>
              </div>
              <div style="float: left;width: 26%">
                <div class="div-right2-top">
                  <span style="font-size: 0.8rem">距离生日:</span>
                  <span
                      :style="{'font-size':'0.8rem','color': item.birthdayInfoModel.nextDay<=10?'red':item.birthdayInfoModel.deadDate !== null?'gray':'blue'}">{{
                      item.birthdayInfoModel.nextDay
                    }}</span>
                  <span style="font-size: 0.8rem">天</span>
                </div>
                <div class="div-right2-bottom">
                  <span style="font-size: 0.8rem">{{ item.birthdayInfoModel.toolTipDetails }}</span>
                </div>
                <div style="clear:both;">
                </div>
              </div>
              <div style="clear: both"></div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <Divider><span>当前：{{ BirthdayList.length }}个生日</span></Divider>
    <div class="empty-div">
      <div>
        <img src="../../../../assets/images/no_data.png" v-if="showEmptyImage" alt=""/>
      </div>
    </div>
  </div>
</template>
<script>
import {Indicator} from 'mint-ui';
import {Divider} from 'vant';
import 'vant/lib/divider/index.css'

export default {
  name: "StarBirthday",
  components: {
    Divider
  },
  data() {
    return {
      searchKey: null,
      BirthdayList: [],
      BirthdayList_Temp: [],
      showEmptyImage: false,
      yhnm: localStorage.getItem('yhnm'),
      token: localStorage.getItem('token'),
      getStarBirthdayListUrl: '/api/star/getStarBirthdayList',
    }
  },
  filters: {
    font_color: function (val) {
      if (val.deadDate !== null) {
        return '<div style="color:gray;float: left">' + val.name + '</div>'
      }
      return '<div style="color:green;float: left">' + val.name + '</div>'
    }
  },
  mounted() {
    this.getBirthdayList()
  },
  methods: {
    changePage() {
      this.$router.replace('m_star_main')
    },
    search() {
      if (this.searchKey === null) {
        return
      }
      if (this.searchKey === '') {
        this.BirthdayList = this.BirthdayList_Temp
        return
      }
      let temp = []
      this.BirthdayList_Temp.forEach(item => {
        if (item.birthdayInfoModel.name.includes(this.searchKey)) {
          temp.push(item)
        }
      })
      this.BirthdayList = temp
    },
    analysis(id) {
      this.$router.push({name: 'm_star_birthday_details', params: {id: id}})
    },
    getBirthdayList() {
      let that = this
      Indicator.open({
        text: '数据加载中...',
        spinnerType: 'fading-circle'
      });
      this.$ajax({
        method: 'get',
        url: this.getStarBirthdayListUrl,
        params: JSON.parse(localStorage.getItem("StarData")),
        headers: {token: this.token, needToken: 'false'}
      }).then((response) => {
        Indicator.close()
        if (!response.data.result)
          that.$messagebox.alert(response.data.message)
        else {
          let responseData = response.data['responseData']
          let list = responseData['data']
          if (that.pageIndex === 1) {
            that.BirthdayList = list
          } else {
            that.BirthdayList = that.BirthdayList.concat(list)
          }
          that.BirthdayList_Temp = that.BirthdayList
          that.showEmptyImage = that.BirthdayList.length <= 0;
        }
      }).catch(response => {
        Indicator.close()
        this.$messagebox.alert(response.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    },
  }
}
</script>

<style lang="less" scoped>
.footer {
  position: fixed;
  bottom: 0;
  height: 30px;
  width: 100%;
  line-height: var(--footer-height);
  background: #42b983;
  color: #fff;
}

/deep/ .vue-contextmenu-listWrapper .context-menu-list .no-child-btn {
  font-size: 16px;
  color: white;
  font-family: 黑体, serif;
  background: #4C4C4C;
  padding-left: 0;
  padding-right: 0;
  border-bottom: solid 0.5px white;
}

/deep/ .vue-contextmenu-listWrapper .context-menu-list .btn-wrapper-simple {
  height: 20px;
}

.right-menu {
  padding: 1.3rem 0 0 0;
  clip-path: polygon(90% 1%, 88% 11%, 100% 11%, 100% 100%, 0 100%, 0 11%, 78% 10%);
}

.rootTable {
  margin-top: -0.5rem;
  padding-bottom: 3.1rem;
  width: 100%;
  height: 100%;

  ul {
    list-style-type: none;
    margin: 3rem 0 0 0;

    li {
      //margin-left: -2.5rem;
    }
  }

  /deep/ .vue-contextmenu-listWrapper {
    background: #4C4C4C;
  }


  .empty-div {
    position: absolute;
    left: 55%;
    top: 40%;
    transform: translate3d(-50%, -50%, 0);
  }

  a {
    text-decoration: none;
    color: blue;
  }

  span {
    font-size: 1.2rem;
  }
}

.popupstyle {
  width: 100px;
  height: 100px;

}

.div-root {
  height: 2.9rem;
  margin-left: -0.5rem;
  min-width: 24rem;
  text-align: left;
  display: flex;
  flex-direction: row;
  width: 100%;
}

.div-left {
  width: 21%;
}

.div-right2 {
  width: 36%;
  margin-left: 0.2rem;
  display: flex;
  line-height: 1.5rem;
  flex-direction: column;

  .div-right2-top {
    max-height: 30%;
    display: table;
    text-align: center;

    span {
      display: table-cell;
      vertical-align: center;
      font-size: 0.9rem;
    }
  }

  .div-right2-bottom {
    max-height: 30%;
    display: table;

    span {
      display: table-cell;
      vertical-align: center;
      font-size: 0.8rem;
      text-align: center;
    }
  }
}

.div-right3 {
  width: auto;
  margin-left: 1.5rem;
  display: flex;
  line-height: 1.5rem;
  flex-direction: column;

  .div-right2-top {
    max-height: 30%;
    display: table;
    text-align: center;

    span {
      display: table-cell;
      vertical-align: center;
      font-size: 0.9rem;
    }
  }

  .div-right2-bottom {
    max-height: 50%;
    display: table;

    span {
      display: table-cell;
      vertical-align: center;
      font-size: 0.8rem;
      width: 33.33%;
      text-align: center;
    }
  }
}

.my-icon-button {
  background-color: #72d878;
  text-align: center;
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
</style>
